import { FeatureFlagName } from '@repo/shared/dtos/feature-flag'
import { useT } from '@repo/ui/hooks'
import { cn } from '@repo/ui/utils'
import { ComponentType, FC, SVGProps } from 'react'
import { Link } from 'react-router-dom'

export type LinkItemProps = {
  className?: string
  feature: FeatureFlagName | 'any'
  icon?: ComponentType<SVGProps<SVGSVGElement>>
  isActive?: boolean
  isDisabled?: boolean
  isOptional?: boolean
  label: string
  to?: string
}

export const LinkItem: FC<LinkItemProps> = ({
  className,
  icon: Icon,
  isActive = false,
  isDisabled = false,
  isOptional = false,
  label,
  to,
}) => {
  const { tc } = useT()
  const content = (
    <>
      {Icon && <Icon className="size-5" />}
      {label}{' '}
      {isOptional && (
        <span className="text-primary-500 text-xs">{tc('optional', { cfl: true })}</span>
      )}
    </>
  )

  const commonClassNames = cn(
    'flex w-full items-center gap-2 rounded-md px-4 py-2 transition-colors duration-200',
    isDisabled ? 'cursor-not-allowed opacity-50' : to ? 'cursor-pointer' : 'cursor-default',
    isActive ? 'bg-primary-500' : to && 'hover:bg-primary-50/10',
    className,
  )

  return to ? (
    <Link to={isDisabled ? '' : to} className={commonClassNames} aria-disabled={isDisabled}>
      {content}
    </Link>
  ) : (
    <div className={commonClassNames} aria-disabled={isDisabled}>
      {content}
    </div>
  )
}
